module.exports = __webpack_public_path__ + "static/img/whater-1.9e3b8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/whater-1.png
// module id = 9pF6
// module chunks = 0